import React, { FC } from 'react';
import useCreditSummary from '@/lib/api/productCatalog/hooks/useCreditSummary';
import { formatReferralCredits } from '@/utils/helpers';
import useLocale from '@/hooks/useLocale';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../RichText';
import { EntryFields } from 'contentful';

export type ReferralBalanceProps = {
  label: string;
  description?: EntryFields.RichText;
  withoutReferralDescription?: EntryFields.RichText;
  precedingPriceText?: string;
};

const ReferralBalance: FC<ReferralBalanceProps> = ({
  label,
  description,
  withoutReferralDescription,
  precedingPriceText,
}) => {
  const { data: creditSummaryData } = useCreditSummary();
  const locale = useLocale();

  const referralBalance =
    creditSummaryData?.credit_summary.credits_available.advocate_rewards
      .total_balance;
  const content =
    Number(referralBalance) > 0 ? description : withoutReferralDescription;

  if (!creditSummaryData) return null;

  return (
    <div>
      <div className="flex gap-1 text-base lg:text-lg">
        <p className="font-bold mb-1">{label}</p>
        <p>
          {precedingPriceText && <span>{precedingPriceText}</span>}
          {formatReferralCredits(Number(referralBalance), locale)}
        </p>
      </div>

      {content && (
        <div className="text-sm lg:text-base" data-testid="description">
          <RichText content={content as Document} />
        </div>
      )}
    </div>
  );
};

export default React.memo(ReferralBalance);
